"use client";

import * as React from "react";
import ConfirmDialog from "components/ui/confirm-dialog";

/**
 * Backwards-compatible wrapper kept so existing imports of
 * `components/ui/confirmationDialog` keep resolving. New code should import
 * `ConfirmDialog` from `components/ui/confirm-dialog`, or use the promise-based
 * `useConfirm()` hook for one-off destructive actions.
 */

export type ConfirmVariant = "default" | "destructive";

export interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: ConfirmVariant;
    isLoading?: boolean;
    size?: "sm" | "md" | "lg" | "xl" | "full";
    align?: "top" | "center";
    autoFocusConfirm?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    description,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    variant = "destructive",
    isLoading = false,
    onConfirm,
    onCancel,
}) => (
    <ConfirmDialog
        open={open}
        title={title}
        description={description}
        tone={variant === "destructive" ? "danger" : "brand"}
        confirmLabel={confirmLabel}
        cancelLabel={cancelLabel}
        isLoading={isLoading}
        onConfirm={onConfirm}
        onCancel={onCancel}
    />
);

export default ConfirmationDialog;
